'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _dec, _class2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _reactCustomScrollbars = require('react-custom-scrollbars');

var _softwares = require('redux/modules/softwares');

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SoftwareDownloadPopupLatest = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(SoftwareDownloadPopupLatest, _React$Component);

  function SoftwareDownloadPopupLatest() {
    (0, _classCallCheck3.default)(this, SoftwareDownloadPopupLatest);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SoftwareDownloadPopupLatest.__proto__ || (0, _getPrototypeOf2.default)(SoftwareDownloadPopupLatest)).call(this));

    _this.state = {
      os: (0, _utils.detectOperatingSystem)()
    };
    return _this;
  }

  (0, _createClass3.default)(SoftwareDownloadPopupLatest, [{
    key: 'handleCancelClick',
    value: function handleCancelClick(e) {
      e.preventDefault();
      this.props.onCloseNo('Cancelled');
    }
  }, {
    key: 'onClickPlatform',
    value: function onClickPlatform(os) {
      this.setState({ os: os });
    }
  }, {
    key: 'renderDownload',
    value: function renderDownload() {
      var _this2 = this;

      var _props = this.props,
          updater = _props.updater,
          title = _props.title,
          icon = _props.icon,
          cover = _props.cover;


      var latest = updater[0];

      var operatingSystems = [];
      operatingSystems.push('Windows');

      if (!!latest.UrlMac) {
        operatingSystems.push('Mac');
      }

      var styles = require('./SoftwareDownloadPopupLatest.scss');

      var renderThumbVertical = function renderThumbVertical() {
        return _react2.default.createElement('div', { style: {
            background: '#A9A9A9',
            width: '8px',
            display: 'block'
          } });
      };

      var renderTrackVertical = function renderTrackVertical(props) {
        return _react2.default.createElement('div', (0, _extends3.default)({}, props, { style: {
            right: 2,
            bottom: 2,
            top: 2,
            borderRadius: 0,
            position: 'absolute',
            width: 8,
            cursor: 'pointer',
            background: '#0F0F0F'
          } }));
      };

      return _react2.default.createElement(
        'div',
        { className: styles.DownloadPopup },
        _react2.default.createElement(
          'div',
          { className: styles.Featured },
          cover.Name
        ),
        _react2.default.createElement(
          _reactCustomScrollbars.Scrollbars,
          { universal: true, autoHeight: true, renderThumbVertical: renderThumbVertical, renderTrackVertical: renderTrackVertical },
          _react2.default.createElement(
            'div',
            { className: styles.DownloadPopup__inner },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: styles.DownloadPopup__Title },
                _react2.default.createElement('img', { src: icon }),
                _react2.default.createElement(
                  'h1',
                  null,
                  title
                )
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_components.Button, {
                className: styles.DownloadPopup__DownloadButton,
                primary: true,
                link: true,
                href: this.state.os.toLowerCase() == 'windows' ? latest.Url : latest.UrlMac,
                label: 'Download ' + (0, _utils.prettyVersion)(latest.Version) })
            ),
            _react2.default.createElement(
              'div',
              { style: { marginBottom: '2em' } },
              _react2.default.createElement(_components.ButtonGroup, { styles: styles, options: operatingSystems, selected: this.state.os, onClick: this.onClickPlatform.bind(this) })
            ),
            _react2.default.createElement(
              'div',
              { className: styles['DownloadPopup__ChangeLog-title'] },
              'Changelist for ' + (0, _utils.prettyVersion)(latest.Version)
            ),
            _react2.default.createElement(
              'ul',
              { className: styles.DownloadPopup__ChangeLog },
              latest.Bullet.map(function (b) {
                return _react2.default.createElement(
                  'li',
                  null,
                  b
                );
              })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.DownloadPopup__OlderVersions },
              _react2.default.createElement(_components.Button, {
                onClick: function onClick(e) {
                  _this2.props.forceClose();

                  setTimeout(function () {
                    _this2.context.dialogs.custom(_react2.default.createElement(_components.SoftwareDownloadPopupOlder, { software: _this2.props.software }));
                  }, 500);
                },
                label: 'older versions',
                disabled: updater.length <= 1 })
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          loading = _props2.loading,
          loaded = _props2.loaded,
          cover = _props2.cover;


      var styles = require('./SoftwareDownloadPopupLatest.scss');

      return _react2.default.createElement(
        _components.PopupBoxWithBackground,
        { image: cover && cover.Url || '', forceClose: this.props.forceClose },
        loading && _react2.default.createElement(
          'div',
          { className: styles.center },
          _react2.default.createElement(_components.LoadingIndicator, null)
        ),
        !loading && loaded && this.renderDownload()
      );
    }
  }]);
  return SoftwareDownloadPopupLatest;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
var SoftwareDownloadPopupLatestContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    softwares: state.softwares
  };
}, null, null, { withRef: true }), _dec(_class2 = (_temp2 = _class3 = function (_React$Component2) {
  (0, _inherits3.default)(SoftwareDownloadPopupLatestContainer, _React$Component2);

  function SoftwareDownloadPopupLatestContainer() {
    (0, _classCallCheck3.default)(this, SoftwareDownloadPopupLatestContainer);
    return (0, _possibleConstructorReturn3.default)(this, (SoftwareDownloadPopupLatestContainer.__proto__ || (0, _getPrototypeOf2.default)(SoftwareDownloadPopupLatestContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(SoftwareDownloadPopupLatestContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props3 = this.props,
          software = _props3.software,
          dispatch = _props3.dispatch,
          softwares = _props3.softwares;


      if (software === 'bridge' && !softwares.bridgeLoaded) dispatch((0, _softwares.loadBridgeUpdater)());

      if (software === 'mixer' && !softwares.mixerLoaded) dispatch((0, _softwares.loadMixerUpdater)());
    }
  }, {
    key: 'forceClose',
    value: function forceClose(reason) {
      this.props.onCloseNo(reason);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          dispatch = _props4.dispatch,
          software = _props4.software,
          softwares = _props4.softwares;


      var title = '',
          loading = false,
          loaded = false,
          cover = '',
          icon = '',
          updater = [];

      if (software == 'bridge') {
        title = "Megascans BRIDGE";
        loading = softwares.loadingBridge;
        loaded = softwares.bridgeLoaded;
        updater = softwares.bridgeUpdater;
        cover = softwares.bridgeCover;
        icon = '/icons/bridge_64.jpg';
      }

      if (software == 'mixer') {
        title = "Quixel MIXER";
        loading = softwares.loadingMixer;
        loaded = softwares.mixerLoaded;
        updater = softwares.mixerUpdater;
        cover = softwares.mixerCover;
        icon = '/icons/studio_64.jpg';
      }

      return _react2.default.createElement(SoftwareDownloadPopupLatest, { software: software, loading: loading, loaded: loaded, updater: updater, title: title, icon: icon, cover: cover, forceClose: this.forceClose.bind(this) });
    }
  }]);
  return SoftwareDownloadPopupLatestContainer;
}(_react2.default.Component), _class3.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp2)) || _class2);
exports.default = SoftwareDownloadPopupLatestContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SoftwareDownloadPopupLatest/SoftwareDownloadPopupLatest.jsx
// module id = 2737
// module chunks = 0